export function footballFormation(team) {
  const counts=String(team?.formation||'').split('-').map(Number);
  const players=team?.starting||[];
  if(counts.length<2||counts.length>5||counts.some(n=>!Number.isInteger(n)||n<1||n>5)||counts.reduce((a,b)=>a+b,0)!==10||players.length!==11)return null;
  const keepers=players.filter(p=>/^(goalkeeper|målvakt|keeper|gk)$/i.test(p.position||''));
  if(keepers.length!==1)return null;
  const outfield=players.filter(p=>p!==keepers[0]);
  if(outfield.every(p=>Number.isInteger(p.formation_slot)) && keepers[0].formation_slot===1 && new Set(players.map(p=>p.formation_slot)).size===11 && players.every(p=>p.formation_slot>=1&&p.formation_slot<=11)) {
    const ordered=[...outfield].sort((a,b)=>a.formation_slot-b.formation_slot);let offset=0;
    return {keeper:keepers[0],rows:counts.map(count=>{const row=ordered.slice(offset,offset+count);offset+=count;return row;})};
  }
  // Row numbers must come from verified source coordinates, never array ordering.
  if(outfield.some(p=>!Number.isInteger(p.formation_row))) {
    const groups=[/^(back|defender|försvarare)$/i,/^(midfielder|mittfältare)$/i,/^(forward|striker|anfallare)$/i].map(pattern=>outfield.filter(p=>pattern.test(p.position||'')));
    if(groups.flat().length!==10||groups.some(row=>!row.length))return null;
    return {keeper:keepers[0],rows:groups,grouped:true};
  }
  const rows=counts.map((count,index)=>outfield.filter(p=>p.formation_row===index+1));
  if(rows.some((row,index)=>row.length!==counts[index]))return null;
  return {keeper:keepers[0],rows};
}
